import ISupplierReference from "../models/product/product"
import { isNullOrEmpty } from "./field-validators"
import { normalizeString } from "./string"

/**
 * Inverts the first and second keys from a tree.
 *
 * Input :
 * {
 *   bar : {
 *     gus : "toto"
 *   },
 *   hut : {
 *     gus : "tata"
 *   }
 * }
 *
 * Output :
 * {
 *   gus : {
 *     bar : "toto",
 *     hut : "tata"
 *   }
 * }
 *
 * @param {Object} id - The Object tree to invert.
 */
export const invertTreeKeys = (tree: any) => {
  return Object.keys(tree).reduce((accumulator = {}, firstKey) => {
    Object.keys(tree[firstKey]).forEach((secondKey) => {
      accumulator[secondKey] = Object.assign(accumulator[secondKey] || {}, {
        [firstKey]: tree[firstKey][secondKey],
      })
    })
    return accumulator
  }, {})
}

/**
 * /**
 * Organises trees with only one depth level of children
 * @param fatherIdKey - String - Key of the FatherID
 * @param idKey - String - Key of the ID
 * @param products - Object - Object to format
 */
export const treeSortOneNestedLevel = (
  fatherIdKey: string,
  idKey: string,
  products: any
) => {
  const productTree = products.reduce((accumulator: any, product: any) => {
    const topRefId = product[fatherIdKey]
    const supplierRef = product[idKey]

    if (!isNullOrEmpty(topRefId) && !accumulator[topRefId]) {
      accumulator[topRefId] = {
        childrens: [],
      }
    } else if (isNullOrEmpty(topRefId) && !accumulator[supplierRef]) {
      accumulator[supplierRef] = {
        childrens: [],
      }
    }

    if (!isNullOrEmpty(topRefId)) {
      accumulator[topRefId].childrens = [
        ...accumulator[topRefId].childrens,
        product,
      ]
    } else {
      accumulator[supplierRef] = { ...accumulator[supplierRef], ...product }
    }

    return accumulator
  }, {})

  return productTree
}

/**
 * treeSortOneNestedLevel's adaptation to products from Bruneau enterprise
 * @param products
 */
export const formatProducts = (products: ISupplierReference[]) =>
  treeSortOneNestedLevel("topRefId", "supplierRef", products)

export const genericConvert = (value: any, type: string) => {
  switch (type) {
    case "number":
      return parseInt(value, 10)

    default:
      return value.toString()
  }
}

export const convertToBoolean = (value: any) =>
  value === 1 ||
  value === "1" ||
  value === true ||
  (typeof value === "string" && normalizeString(value) === "true")
